<template>
  <article>
    <b-row>
      <LmTextInput
        class="col-4"
        :placeholder="$t('name')"
        :label="$t('name')"
        :v="$v.value.name"
        v-model="value.name"
      />
      <LmTextInput
        class="col-4"
        :placeholder="$t('title')"
        :label="$t('title')"
        :v="$v.value.title"
        v-model="value.title"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('avaible_sizes')"
        type="multiple"
        :options="sizesOptions"
        v-model="value.sizes"
      />
    </b-row>
  </article>
</template>

<script>
// Utils
import { required } from 'vuelidate/lib/validators'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'

export default {
  components: {
    LmTextInput,
    LmCheckbox
  },
  props: {
    value: Object,
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataOriginOptions: [],
      sizesOptions: [
        {
          text: '25%',
          value: 3
        },
        {
          text: '50%',
          value: 6
        },
        {
          text: '75%',
          value: 9
        },
        {
          text: '100%',
          value: 12
        }
      ]
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      title: {
        required
      }
    }
  }
}
</script>
